import PropTypes from 'prop-types';
import Small from 'UIComponents/elements/Small';
import UILoadingDots from 'UIComponents/loading/UILoadingDots';
import ToolLink from './ToolLink';
import ToolLinksRecord from '../records/ToolLinksRecord';
import Track from '../../shared/utils/trackers/ZorseCrmComponentsTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function NullableToolLink(props) {
  return props.url ? /*#__PURE__*/_jsx(ToolLink, Object.assign({}, props)) : null;
}

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message

function ToolLinks({
  toolLinks
}) {
  return toolLinks ? /*#__PURE__*/_jsx("div", {
    children: toolLinks.loading ? /*#__PURE__*/_jsx(UILoadingDots, {
      "data-test-id": "tool-links-loading",
      grow: false
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NullableToolLink, {
        onClick: Track.clickZorseTicket,
        text: "Zorse ticket",
        url: toolLinks.zorseTicketLink
      }), /*#__PURE__*/_jsx(NullableToolLink, {
        onClick: Track.clickSourceUrl,
        text: "Source URL",
        url: toolLinks.chatSourceLink
      }), /*#__PURE__*/_jsx(NullableToolLink, {
        isCopyable: true,
        label: "Hub ID",
        onClick: Track.clickHubId,
        text: toolLinks.hubId,
        url: toolLinks.hubIdLink
      }), /*#__PURE__*/_jsx(NullableToolLink, {
        onClick: Track.clickHubDetails,
        text: "Hub Details",
        url: toolLinks.hubDetailsLink
      }), /*#__PURE__*/_jsx(NullableToolLink, {
        onClick: Track.clickSupportToolbox,
        text: "Support Toolbox",
        url: toolLinks.fccSupportInboxLink
      }), /*#__PURE__*/_jsx(NullableToolLink, {
        onClick: Track.clickEmailSupportTools,
        text: "Email Support Tools",
        url: toolLinks.emailSupportToolLink
      }), /*#__PURE__*/_jsx(NullableToolLink, {
        onClick: Track.clickSqlLink,
        text: "Submit a Service Qualified Lead",
        url: toolLinks.sqlFormLink
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-4",
        children: /*#__PURE__*/_jsxs(Small, {
          use: "help",
          children: ["Powered by ", /*#__PURE__*/_jsx("b", {
            children: "Revenue"
          })]
        })
      })]
    })
  }) : null;
}
ToolLinks.propTypes = {
  toolLinks: PropTypes.instanceOf(ToolLinksRecord)
};
ToolLinks.defaultProps = {
  toolLinks: undefined
};
export default ToolLinks;